import CarouselNavigation from './CarouselNavigation';
import { connect } from './connect';

export default connect(CarouselNavigation);
